import { GruppoRami } from './gruppo-rami';
import { Model } from './model';
import { Polizza } from './polizza';

export class Ramo extends Model {
  static apiUrl: string = "rami";

  nome: string;
  codice: string;

  polizze: Polizza[];
  gruppo_rami: GruppoRami;

  deserialize(input: any): Ramo {
    let retV: Ramo = new Ramo();

    retV = super.deserialize(input) as Ramo;

    if (input?.polizze) {
      retV.polizze = input.polizze.map(m => new Polizza().deserialize(m));
    }

    if (input?.gruppo_rami) {
      retV.gruppo_rami = new GruppoRami().deserialize(input.gruppo_rami);
    }


    return retV;
  }


  static getDefaultSortKey() {
    return 'nome';
  }
  static getDefaultSortDirection() {
    return 'asc';
  }

}
